import { motion } from "framer-motion";
import { Mail, MapPin, Phone } from "lucide-react";
import { scrollToId } from "@/hooks/useLenis";

export const Footer = () => (
  <footer data-testid="footer-section" className="relative border-t border-amber-500/15 bg-[#0c0c10]">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-10 sm:py-24">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <img src="/assets/logo.png" alt="Exclusive Reykjavik" className="h-20 w-auto mix-blend-screen" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-neutral-400">
            Based in Reykjavík since 2015, operating worldwide. Hotels, transport, tours, dining, nightlife and
            impossible private events — one key opens them all.
          </p>
          <button
            data-testid="footer-cta-start"
            onClick={() => scrollToId("#services")}
            className="mt-8 border border-amber-500/40 px-6 py-3 text-xs font-semibold uppercase tracking-[0.25em] text-amber-200 transition-colors duration-300 hover:bg-amber-500 hover:text-black"
          >
            Begin a Request
          </button>
        </motion.div>

        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-amber-300/80">Concierge Desk</p>
          <ul className="mt-6 space-y-4 text-sm text-neutral-300">
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 shrink-0 text-amber-400/70" />
              <a data-testid="footer-email-link" href="mailto:viking@exclusivereykjavik.is" className="transition-colors hover:text-amber-200">
                viking@exclusivereykjavik.is
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 shrink-0 text-amber-400/70" />
              <a data-testid="footer-phone-link" href="tel:+3546150055" className="transition-colors hover:text-amber-200">
                +354 615 0055 — 24/7
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-amber-400/70" />
              <span>
                Laugavegur 26, 101 Reykjavík
                <br />
                Iceland
              </span>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-amber-300/80">The Promise</p>
          <ul className="mt-6 space-y-3 text-sm text-neutral-400">
            <li>Reply within hours, day or night</li>
            <li>One concierge, end to end</li>
            <li>Absolute discretion, always</li>
            <li>Iceland first — the world after</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-amber-500/10 pb-20 pt-8 sm:pb-0">
        <p className="text-[10px] uppercase tracking-[0.3em] text-neutral-600">
          © 2026 Exclusive Reykjavik · Est. 2015 · All rights reserved.
        </p>
        <p className="font-serif text-sm italic text-amber-200/50">Key to the city — and beyond.</p>
        <a
          href="/owner"
          data-testid="footer-owner-access"
          className="text-[10px] uppercase tracking-[0.3em] text-neutral-700 transition-colors hover:text-amber-200"
        >
          Admin Access
        </a>
      </div>
    </div>
  </footer>
);
